import { graphqlRequest } from "../graphqlClient";
import type {
	AllTransactionViewConnection,
	AllTransactionViewFilterInput,
} from "../models/allTransactionView";

export interface AllTransactionViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

interface AllTransactionViewListResponse {
	transactions: {
		allTransactionViewList: AllTransactionViewConnection;
	};
}

export async function getAllTransactionsGraphql(
	filter?: AllTransactionViewFilterInput,
	first?: number,
	after?: string,
	sort?: AllTransactionViewSortInput[],
): Promise<AllTransactionViewConnection> {
	const query = `
    query AllTransactionViewList($filter: AllTransactionViewFilterInput, $first: Int, $after: String, $sort: [AllTransactionViewSortSortByInput!]) {
      transactions {
        allTransactionViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              source
              externalId
              reference
              accountCode
              accountName
              description
              transactionType
              amount
              outstanding
              transactionDate
              dueDate
              anticipatedPaymentDate
              category
              status
              dataSourceId
              dataSourceName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<AllTransactionViewListResponse>(query, {
		filter,
		first,
		after,
		sort,
	});
	return data.transactions.allTransactionViewList;
}

interface AllTransactionViewCountResponse {
	transactions: {
		allTransactionViewCount: number;
	};
}

export async function getAllTransactionsCount(
	filter?: AllTransactionViewFilterInput,
): Promise<number> {
	const query = `
    query AllTransactionViewCount($filter: AllTransactionViewFilterInput) {
      transactions {
        allTransactionViewCount(filter: $filter)
      }
    }
  `;
	const data = await graphqlRequest<AllTransactionViewCountResponse>(query, {
		filter,
	});
	return data.transactions.allTransactionViewCount;
}
